import React from 'react';
import { sanitizeHtml } from '../../../lib/sanitizeHtml';
import type { Block } from '../../../types/parcours';

interface RichTextBlock extends Block {
  type: 'rich-text';
  html?: string;
  payload?: { html?: string };
}

interface Props {
  block: RichTextBlock;
}

export default function RichTextBlock({ block }: Props) {
  const raw = block.html ?? block.payload?.html;
  if (!raw) return null;

  const clean = sanitizeHtml(raw);

  return (
    <div
      className="rtx"
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
